import { render, staticRenderFns } from "./ClientCafeList.vue?vue&type=template&id=fd95e1e6&scoped=true"
import script from "./ClientCafeList.vue?vue&type=script&lang=js"
export * from "./ClientCafeList.vue?vue&type=script&lang=js"
import style0 from "./ClientCafeList.vue?vue&type=style&index=0&id=fd95e1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd95e1e6",
  null
  
)

export default component.exports